import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IProcedurePrice } from 'app/shared/model/procedure-price.model';
import { IHospitalPatientCategoryAttributes } from 'app/shared/model/hospital-patient-category-attributes.model';

export interface IPatientProcedureCharge {
  id?: string;
  performedDate?: number;
  active?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  fromDate?: number;
  toDate?: number | null;
  discount?: number | null;
  procedure?: IPatientProcedure | null;
  appliedCharge?: IProcedurePrice | null;
  multiplierEntry?: IHospitalPatientCategoryAttributes | null;
}

export const defaultValue: Readonly<IPatientProcedureCharge> = {
  active: false,
};
